<template>
  <div id="product-options-dropdown">

        <div v-for="po in product_options" :key="po.id" class="product-options-filter group" v-if="product_options.length > 0">

                <div class="form-floating" v-if="po.product_option_keys && Object.keys(po.product_option_keys).length > 0">
                  <select @change="handleDropdownChange(po.slug)" v-model="selected_options[po.slug]" class="form-select" :id="po.slug + 'Select'">
                    <option :value="pok.id" :label="pok.value" v-for="pok in po.product_option_keys" :key="pok.id">{{pok.value}} </option>
                  </select>
                  <label :for="po.slug + 'Select'">Select {{po.name}}</label>
                </div>

                <br v-if="po.product_option_keys && Object.keys(po.product_option_keys).length > 0">

        </div>


       <div class="product-attributes-filter group">

                <div v-if="typeof engines !== 'undefined' && engines.length > 1" class="form-floating">
                  <select class="form-select" id="EngineSelect" aria-label="Select Engine" name="engine" v-model="engine">
                    <option :value="eng" v-for="(eng, index) in engines">{{ engineslabels[index] }}</option>
                  </select>
                  <label for="EngineSelect">Select Engine</label>
                </div>

                <br v-if="typeof engines !== 'undefined' && engines.length > 1">

                <div v-if="typeof years !== 'undefined' && years.length > 1" class="form-floating">
                  <select class="form-select" id="YearSelect" aria-label="Select Year" name="year" v-model="year">
                    <option :value="year" v-for="year in years">{{year}}</option>
                  </select>
                  <label for="YearSelect">Select Year</label>
                </div>

                <br v-if="typeof years !== 'undefined' && years.length > 1">

                <div v-if="typeof transmissions !== 'undefined' && transmissions.length > 1" class="form-floating">
                  <select class="form-select" id="TransmissionSelect" aria-label="Select Transmission" name="transmission" v-model="transmission">
                    <option :value="transmission" v-for="transmission in transmissions">{{transmission}}</option>
                  </select>
                  <label for="TransmissionSelect">Select Transmission</label>
                </div>

                <br v-if="typeof transmissions !== 'undefined' && transmissions.length > 1">

        </div>



  </div>



</template>
<script>
    import {bus} from '../../bus'
    export default {
        name: "ProductOptionsDropdowns",
        props: ["product_options", "selected_options", "engines", "engineslabels", "years", "engine", "year", "transmissions", "transmission"],
        watch: {
            engine: function(val) {
                let urlparams = '?engine=' + val;
                //let poId = this.getPoId();
                //if(poId) urlparams = urlparams + "&poid=" + poId;
                urlparams = urlparams + "#prod-title";
                window.location.href = window.location.pathname + urlparams;
            },
            year: function(val) {
                let urlparams = '?engine=' + this.engine + "&year=" + val;
                //let poId = this.getPoId();
                //if(poId) urlparams = urlparams + "&poid=" + poId;
                urlparams = urlparams + "#prod-title";
                let url = window.location.pathname;
                url = url.replace('/new_cat_', '/cat_');
                window.location.href = url + urlparams;
            },
            transmission: function(val) {
                window.location.href = window.location.pathname + '?engine=' + this.engine + "&year=" + this.year + "&transmission=" + val + "#prod-title" ;
            }
        },

        mounted() {


//console.log('this.engines', this.engines);

//console.log('this.engineslabels', this.engineslabels);

//console.log('this.years', this.years);

//console.log('mounted()');
//console.log('window.location', window.location);
//console.log('this.product_options', this.product_options);
//console.log('this.selected_options', this.selected_options);




/*
            this.$root.$on('product-attributes-engine', data => {
                console.log('engine', data);
            });

            this.$root.$on('product-attributes-year', data => {
                console.log('year', data);
            });
*/
        },

      methods: {

        getPoId() {

                if(this.selected_options) {
                    let slug = Object.keys(this.selected_options)[0];

                    let pokId = this.selected_options[slug];
                    let prodId = false;

                    for( let x in this.product_options ) {
                      for( let y in this.product_options[x].product_option_keys ) {
                        if( this.product_options[x].product_option_keys[y].id == pokId ) {
                            prodId = this.product_options[x].product_option_keys[y].product_id;
                            break;
                        }
                      }
                    }

                    return prodId;

                }

                return false;


        },

        getPoUrl() {

                if(this.selected_options) {
                    let slug = Object.keys(this.selected_options)[0];

                    let pokId = this.selected_options[slug];
                    let prodId = false;

                    for( let x in this.product_options ) {
                      for( let y in this.product_options[x].product_option_keys ) {
                        if( this.product_options[x].product_option_keys[y].id == pokId ) {
                            prodId = this.product_options[x].product_option_keys[y].product_url;
                            break;
                        }
                      }
                    }

                    return prodId;

                }

                return false;


        },




        async handleDropdownChange(slug) {

/*
console.log('slug', slug);
console.log('this.selected_options['+slug+']', this.selected_options[slug]);
*/

            let pokId = this.selected_options[slug];

            let prodId = false;

//console.log('this.product_options', this.product_options);


            for( let x in this.product_options ) {
//console.log('this.product_options[x].product_option_keys', this.product_options[x].product_option_keys);


                  for( let y in this.product_options[x].product_option_keys ) {

//console.log('this.product_options[x].product_option_keys[y]', this.product_options[x].product_option_keys[y]);

                    if( this.product_options[x].product_option_keys[y].id == pokId ) {
                        prodId = this.product_options[x].product_option_keys[y].product_id;
                        break;
                    }
                }


            }



            let url = window.location.pathname;

            if( url.search('/cat_') !== -1 ) {
                let urlparams = '?poid=' + prodId;
                if( this.engine ) urlparams = urlparams + '&engine=' + this.engine;
                if( this.year ) urlparams = urlparams + '&year=' + this.year;
                window.location.href = url + urlparams;
                return;
            }

            let prodUrl = false;

//console.log('this.product_options', this.product_options);


            for( let x in this.product_options ) {
//console.log('this.product_options[x].product_option_keys', this.product_options[x].product_option_keys);


                  for( let y in this.product_options[x].product_option_keys ) {

//console.log('this.product_options[x].product_option_keys[y]', this.product_options[x].product_option_keys[y]);

                    if( this.product_options[x].product_option_keys[y].id == pokId ) {
                        prodUrl = this.product_options[x].product_option_keys[y].product_url;
                        break;
                    }
                }


            }

            url = window.location.protocol + '//' + window.location.host;

            url = url + '/' + prodUrl + '.html';

//console.log('url', url);



            window.location.href = url;

        }
      }



        }
</script>

<style scoped>

.form-floating {
    position: relative;
}

.form-floating > .form-select {
    padding-top: 24px;
    padding-bottom: 0.625rem;
    text-transform: capitalize;
    font-size: 24px;
}
.form-floating>.form-control, .form-floating>.form-select {
    height: 64px;
    line-height: 1.25;
}

.form-floating>.form-control:focus~label, .form-floating>.form-control:not(:placeholder-shown)~label, .form-floating>.form-select~label {
    opacity: .65;
    transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);
}


.form-select {
    transition: none;
}
.form-select {
    display: block;
    width: 100%;
    padding: .375rem 2.25rem .375rem .75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.form-floating>label {
    transition: none;
}
.form-floating>label {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 1rem 0.75rem;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity .1s ease-in-out,transform .1s ease-in-out;
    font-size: 16px;
}

</style>